/* eslint-disable no-undef */
import ItemsView from "../../../components/pos/items";
import ScanView from "../../../components/pos/scan";
import ToolsView from "../../../components/pos/tools";
import PaymentCashView from "../../../components/pos/paymentcash";
import PaymentCreditView from "../../../components/pos/paymentcredit";
import ShiftopenModalView from "../../../components/pos/shiftopenmodal";
import ShiftcloseModalView from "../../../components/pos/shiftclosemodal";
import HoldingBillModalView from "../../../components/pos/holdingbill";
import Swal from "sweetalert2";
import itemDetailView from "../../../components/pos/item_detail";
import checkDetailBill from "../../../components/check_detail_bill";
import stockInfo from "../../../components/stock_info";
import stockCancel from "../../../components/stock_cancel";
import api from "../../../services/service_pos";
import apiItem from "../../../services/service_item";
import apiCenterV2 from "../../../services/service_undefined_v2";

export default {
  components: {
    ItemsView,
    ScanView,
    ToolsView,
    PaymentCashView,
    PaymentCreditView,
    ShiftopenModalView,
    ShiftcloseModalView,
    HoldingBillModalView,
    itemDetailView,
    checkDetailBill,
    stockInfo,
    stockCancel
  },
  data() {
    return {
      mode_type: 1,
      hostshift: "",
      hold: 0,
      item_modal: {
        name: null,
        item_data: {
          bar_data: []
        }
      },
      header: {
        headers: {
          "Access-Token": sessionStorage.token
        }
      },
      editstatus: 0,
      type_payment: 0
    };
  },
  created() {
    this.checkUser();
    this.$store.commit("clearOrderPayment");
    console.log("sessionStorage.hostshift", sessionStorage.hostshift);
    if (sessionStorage.hostshift !== undefined) {
      this.hostshift = JSON.parse(sessionStorage.hostshift);
      console.log(
        "id:",
        this.hostshift.id,
        "status:",
        this.hostshift.is_closed
      );
    } else {
      location.reload();
    }
  },
  methods: {
    setMode(type) {
      this.mode_type = type;
    },
    reloadItem() {
      this.mode_type = 0;
      setTimeout(() => {
        this.mode_type = 1;
      }, 50);
    },
    openShiftModal() {
      Swal.fire({
        title: "ปิดการขายปัจจุบัน",
        text: "ท่านต้องการปิดการขายปัจจุบันใช่หรือไม่ ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ตกลง"
      }).then(result => {
        if (result.value) {
          this.$store.commit("Loading");
          var obj = {
            cash_amount: 0,
            bank_amount: 0,
            change_amount: 0,
            credit_amount: 0,
            chq_amount: 0,
            promptpay_amount: 0,
            coupon_amount: 0,
            expense_amount: 0,
            my_description: "",
            host_code: this.hostshift.host_code,
            id: this.hostshift.id
          };
          api.closeShift(
            this.REST_URL,
            obj,
            this.header,
            result => {
              if (result.response === "success") {
                this.$store.commit("clearOrderPayment");
                this.openCashBox(this.hostshift);
                $("#ShiftModal").modal("show");
              } else {
                this.$notification["warning"]({
                  message: "ปิดการขายไม่ได้",
                  description: result.message
                });
              }
              this.$store.commit("Loading");
            },
            error => {
              alert("ไม่สามารถเข้าถึงข้อมูล " + JSON.stringify(error));
              this.$store.commit("Loading");
            }
          );
        }
      });
    },
    clearOrder() {
      Swal.fire({
        title: "ล้างรายการปัจจุบัน",
        text: "ท่านต้องการล้างรายการปัจจุบันทั้งหมดใช่หรือไม่ ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes"
      }).then(result => {
        if (result.value) {
          this.$store.commit("clearOrderPayment");
          this.$notification["success"]({
            message: "ล้างรายการปัจจุบัน",
            description: "ล้างรายการปัจจุบันสำเร็จ!!"
          });
        } else {
          $("body").on("hidden.bs.modal", ".modal", function() {
            $(this).removeData("bs.modal");
          });
        }
      });
    },
    submitCash() {
      this.type_payment = 0;
      if (this.$store.state.order_data.item_amount > 0) {
        this.hold = 0;
        this.$store.state.order_data.sub = this.$store.state.item_subs;
        this.$store.state.order_data.host_code = this.hostshift.host_code;
        this.$store.state.order_data.bill_type = 0;
        this.$store.state.order_data.item_amount = Math.ceil(
          parseFloat(this.$store.state.order_data.item_amount)
        );
        this.$store.state.order_data.discount_amount = parseFloat(
          this.$store.state.order_data.discount_amount
        );
        $("#PaymentModal").modal("show");
      }
    },
    submitCashDefault() {
      this.type_payment = 1;
      setTimeout(() => {
        if (this.$store.state.order_data.item_amount > 0) {
          this.hold = 0;
          this.$store.state.order_data.sub = this.$store.state.item_subs;
          this.$store.state.order_data.host_code = this.hostshift.host_code;
          this.$store.state.order_data.bill_type = 0;
          this.$store.state.order_data.item_amount = Math.ceil(
            parseFloat(this.$store.state.order_data.item_amount)
          );
          this.$store.state.order_data.discount_amount = parseFloat(
            this.$store.state.order_data.discount_amount
          );
          setTimeout(() => {
            $("#PaymentModal").modal("show");
          }, 200);
        }
      }, 300);
    },
    submitCredit() {
      if (this.$store.state.order_data.item_amount > 0) {
        this.hold = 0;
        this.$store.state.order_data.sub = this.$store.state.item_subs;
        this.$store.state.order_data.host_code = this.hostshift.host_code;
        this.$store.state.order_data.bill_type = 1;
        this.$store.state.order_data.item_amount = Math.ceil(
          parseFloat(this.$store.state.order_data.item_amount)
        );
        this.$store.state.order_data.discount_amount = parseFloat(
          this.$store.state.order_data.discount_amount
        );
        $("#PaymentModal").modal("show");
      }
    },
    submitHolding() {
      if (this.$store.state.order_data.id) {
        this.$notification["warning"]({
          message: "ไม่สามารถพักบิลได้",
          description: "มีการดึงใบพักมาใช้งาน กรุณาล้างบิลเพื่อทำรายการใหม่"
        });
        return;
      }
      if (this.$store.state.order_data.item_amount > 0) {
        this.hold = 1;
        this.$store.state.order_data.sub = this.$store.state.item_subs;
        this.$store.state.order_data.host_code = this.hostshift.host_code;
        this.$store.state.order_data.shift_id = parseFloat(this.hostshift.id);
        this.$store.state.order_data.bill_type = 0;
        this.$store.state.order_data.item_amount = Math.ceil(
          parseFloat(this.$store.state.order_data.item_amount)
        );
        this.$store.state.order_data.discount_amount = parseFloat(
          this.$store.state.order_data.discount_amount
        );
        $("#PaymentModal").modal("show");
      }
    },
    removeListOrder(index) {
      if (this.$store.state.order_data.id) {
        this.$notification["warning"]({
          message: "ไม่สามารถแก้ไขสินค้าได้",
          description: "กำลังดึงใบพักบิล กรุณาล้างบิลเพื่อทำรายการใหม่"
        });
        return;
      }
      this.$store.state.item_subs.splice(index, 1);
      this.$store.state.order_data.item_amount = 0;
      this.$store.state.item_subs.forEach(val => {
        this.$store.state.order_data.item_amount += val["total_amount"];
      });
      if (this.$store.state.item_subs.length === 0) {
        this.$store.state.order_data.multiple = false;
      }
    },
    decreaseItemInAPI(branchName) {
      let summeryweight = 0.0;
      this.$store.state.order_data.sub.map(e => {
        if (e.item_data.group_code === "60") {
          summeryweight = summeryweight + e.item_data.weight * e.qty;
        }
      });

      apiCenterV2.decreaseRemain(
        {
          stockDate: new Date(),
          stock_qty: summeryweight,
          createdBy: "admin"
        },
        this.header,
        results => {
          if (results.data.isStatus) {
            console.log(results.data);
          } else {
          }
        },
        errors => {
          this.$notification["warning"]({
            message: "ไม่สามารถทำการลดจำนวนสินค้าข้าวหม่าได้",
            description: errors.data.message
          });
        }
      );
    },
    hodingOrder() {
      if (!this.$store.state.order_data.ar_code) {
        Swal.fire({
          icon: "warning",
          title: "กรุณาเลือกลูกค้า",
          showConfirmButton: false,
          timer: 2000
        });
        return;
      }
      if (this.$store.state.order_data.item_amount > 0) {
        this.hold = 1;
        this.$store.state.order_data.sub = this.$store.state.item_subs;
        this.$store.state.order_data.host_code = this.hostshift.host_code;
        this.$store.state.order_data.shift_id = parseFloat(this.hostshift.id);
        this.$store.state.order_data.bill_type = 0;
        this.$store.state.order_data.item_amount = Math.ceil(
          parseFloat(this.$store.state.order_data.item_amount)
        );
        // this.$store.state.order_data.item_amount = parseFloat(this.$store.state.order_data.item_amount)
        this.$store.state.order_data.discount_amount = parseFloat(
          this.$store.state.order_data.discount_amount
        );
        console.log("holding order");
        this.$store.commit("Loading");

        let product = this.$store.state.order_data.sub;

        apiCenterV2.updateStock(
          {
            product: product
          },
          this.header,
          results => {},
          errors => {
            this.$notification["warning"]({
              message: "ไม่สามารถทำการลดจำนวนสินค้าข้าวหม่าได้",
              description: errors.data.message
            });
          }
        );

        this.decreaseItemInAPI();
        api.holdBill(
          this.REST_URL,
          this.$store.state.order_data,
          this.header,
          result => {
            if (result.response === "success") {
              $("#PaymentModal").modal("hide");
              this.$store.commit("clearOrderPayment");
              Swal.fire({
                title: "พักบิลสำเร็จ",
                text: "ท่านต้องการพิมพ์ใบแจ้งยอดหรือไม่ ?",
                icon: "success",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes"
              }).then(res => {
                if (res.value) {
                  this.printHoldingBill(result.data.doc_no);
                } else {
                  $("body").on("hidden.bs.modal", ".modal", function() {
                    $(this).removeData("bs.modal");
                  });
                }
              });
            } else {
              this.$notification["warning"]({
                message: "ทำการพักบิลไม่ได้",
                description: result.message
              });
            }
            this.$store.commit("Loading");
          },
          error => {
            // Swal.fire({
            //   icon: 'error',
            //   title: 'ไม่สามารถเข้าถึงข้อมูล',
            //   text: JSON.stringify(error)
            // })
            alert("ไม่สามารถเข้าถึงข้อมูล " + JSON.stringify(error));
            this.$store.commit("Loading");
          }
        );
      }
    },
    check_discount() {
      // eslint-disable-next-line use-isnan
      if (
        parseFloat(this.$store.state.order_data.discount_amount) < 1 ||
        this.$store.state.order_data.discount_amount === ""
      ) {
        this.$store.state.order_data.discount_amount = 0;
      }
    },
    printHoldingBill(docNo) {
      var obj = {
        printer_port: this.hostshift.printer_port,
        doc_no: docNo
      };
      api.printHolding(
        this.REST_URL,
        obj,
        this.header,
        result => {
          if (result.response === "success") {
            this.$notification["success"]({
              message: "พิมพ์ใบแจ้งยอดสำเร็จ",
              description: result.message
            });

            $("body").on("hidden.bs.modal", ".modal", function() {
              console.clear();
              $(this).removeData("bs.modal");
            });
          } else {
            this.$notification["warning"]({
              message: "พิมพ์ใบแจ้งยอดไม่ได้",
              description: result.message
            });

            $("body").on("hidden.bs.modal", ".modal", function() {
              console.clear();
              $(this).removeData("bs.modal");
            });
          }
        },
        error => {
          alert("ไม่สามารถเข้าถึงข้อมูล " + JSON.stringify(error));
          $("body").on("hidden.bs.modal", ".modal", function() {
            console.clear();
            $(this).removeData("bs.modal");
          });
        }
      );
    },
    select_item(data) {
      // console.log(this.$store.state.user.username)
      console.log(data);
      if (this.$store.state.order_data.id) {
        if (this.$store.state.user.username !== "admin") {
          this.$notification["warning"]({
            message: "ไม่สามารถแก้ไขสินค้าได้",
            description: "กำลังดึงใบพักบิล กรุณาล้างบิลเพื่อทำรายการใหม่"
          });
          return;
        }
      }
      this.item_modal = data;
      if (this.$store.state.order_data.id) {
        apiItem.itemById(
          this.REST_URL,
          this.header,
          { id: parseInt(data.id) },
          result => {
            if (result.response === "success") {
              this.item_modal.item_data.bar_data = result.data.bar_data;
            } else {
              this.$notification["warning"]({
                message: "ดึงข้อมูลหน่วยนับไม่ได้",
                description: result.message
              });
            }
          },
          error => {
            alert("ไม่สามารถเข้าถึงข้อมูลสินค้า " + JSON.stringify(error));
          }
        );
      }
      $("#itemDetail").modal("show");
    },
    openDetailBill() {
      $("#itemDetailBill").modal("show");
    },
    checkOpenShift() {
      if (this.hostshift.is_closed === 0 && this.hostshift.change_begin === 0) {
        $("#ShiftModal").modal("show");
      } else if (this.hostshift.is_closed === 1) {
        $("#ShiftModal").modal("show");
      }
    }
  },
  mounted() {
    $("body").on("hidden.bs.modal", ".modal", function() {
      $(this).removeData("bs.modal");
    });
    this.checkOpenShift();
  }
};



// WEBPACK FOOTER //
// ./src/assets/js/pos/pos.js